import {GridColumn, GridColumnGroupDef} from "@data/interefaces/data.interfaces";
import {LongDataColumnComponent} from "@pages/segments/grid/columns/long-data-column/long-data-column.component";
import {ColumnFilterType} from "@data/enums/data.enums";
import {Util} from "@data/util/util";

export let pageContext: {
  [key: string]: boolean | string | undefined
  sid_f: string | undefined;
  ssd_f: string | undefined;
  su_f: string | undefined;
  sg_f: string | undefined;
  sed_f: string | undefined;
  sem_f: string | undefined;
  pn_f: string | undefined;
  plsd_f: string | undefined;
  pled_f: string | undefined;
  pld_f: string | undefined;
  aad_f: string | undefined;
  l_f: string | undefined;
  dt_f: string | undefined;
  pti_f: string | undefined;
  sd_f: string | undefined;
  mode : string | undefined;
  scale : string | undefined;
} = {
  sid_f: undefined,
  ssd_f: undefined,
  su_f: undefined,
  sg_f: undefined,
  sed_f:  undefined,
  sem_f:  undefined,
  pn_f:  undefined,
  plsd_f:  undefined,
  pled_f:  undefined,
  pld_f:  undefined,
  aad_f:  undefined,
  l_f: undefined,
  dt_f: undefined,
  pti_f: undefined,
  sd_f: undefined,
  mode: undefined,
  scale: undefined,
}

export let tableColumns: (GridColumn | GridColumnGroupDef)[] = [
  {
    field: 'sessionId',
    headerName: 'Session Id',
    filterId: 'sid_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
    hide: true,
  },
  {
    field: 'sessionStartTimestamp',
    headerName: 'Session Start Datetime',
    filterId: 'ssd_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      inRangeInclusive: true,
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDateWithMilliseconds(params.value);
    },
    sort: "desc",
    initialSortIndex: 1,
  },
  {
    field: 'detailsObj.name',
    headerName: 'Session User',
    filterId: 'su_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
    sort: "desc",
    initialSortIndex: 2,
  },
  {
    field: 'oktaGroups',
    headerName: 'Session Groups',
    filterId: 'sg_f',
    dbFilter: true,
    hide: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
  },
  {
    field: 'sessionEndTimestamp',
    headerName: 'Session End Datetime',
    filterId: 'sed_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      inRangeInclusive: true,
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDateWithMilliseconds(params.value);
    },
    hide: true
  },
  {
    field: 'sessionEndMethod',
    headerName: 'Session End Method',
    filterId: 'sem_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
    hide:true,
  },
  {
    field: 'sessionDuration',
    headerName: 'Session Duration',
    filter: ColumnFilterType.NUMBER,
    filterId: 'sd_f',
    dbFilter: true,
    filterParams: {
      filterOptions: ['greaterThanOrEqual', 'lessThanOrEqual', 'inRange', 'notBlank'],
      inRangeInclusive: true,
      defaultOption: 'inRange',
      maxNumConditions: 1,
      //allow only number and colon,
      //this pattern doesn't validate target string but only input chars one by one so we can't add something like: \d{2}:[0-50-9]{2}:[0-50-9]{2}
      allowedCharPattern: '\\d:',
      buttons: ['reset'],
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return params.data?.sessionDuration ?  Util.formatMillisecondDuration(params.value) : '';
    }
  },
  {
    field: 'sessionDetails',
    headerName: 'Session Details',
    hide: true,
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        text: params.data?.sessionDetails || '',
        type: params.data?.sessionDetails ? 'json' : 'text'
      };
    },
    flex: 1,
    autoHeight: true,
    filter: false,
  },
  {
    field: 'tabId',
    headerName: 'Page Tab ID',
    filterId: 'pti_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
  },
  {
    field: 'loadName',
    headerName: 'Page Name',
    filterId: 'pn_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    enableRowGroup: true,
    initialWidth: 200,
  },
  {
    field: 'detailsObj.locale',
    headerName: 'Language',
    filterId: 'l_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    hide:true,
  },
  {
    field: 'deviceType',
    headerName: 'Device Type',
    filterId: 'dt_f',
    dbFilter: true,
    filter: ColumnFilterType.DROPDOWN,
    filterParams: {
      defaultToNothingSelected: true,
      buttons: ['reset']
    },
    autoHeight: true,
    cellRenderer: (params: any) => {
      return params.value ? params.value : '';
    },
    hide: true,
  },
  {
    field: 'browserInformation',
    headerName: 'Browser Information',
    hide: true,
    flex: 1,
    autoHeight: true,
    cellRenderer: (params: any) => {
      return params.value ? params.value : '';
    },
  },
  {
    field: 'loadStartDatetime',
    headerName: 'Page Load Start Datetime',
    filterId: 'plsd_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      inRangeInclusive: true,
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDateWithMilliseconds(params.value);
    },
    sort: "desc",
    initialSortIndex: 3,
  },
  {
    field: 'loadEndDatetime',
    headerName: 'Page Load End Datetime',
    filterId: 'pled_f',
    filter: ColumnFilterType.DATE,
    filterParams: {
      defaultOption: 'inRange',
      inRangeInclusive: true,
      maxNumConditions: 1,
      comparator: Util.dateComparator,
      buttons: ['reset']
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.getFormattedDateWithMilliseconds(params.value);
    }
  },
  {
    field: 'loadDuration',
    headerName: 'Page Load Duration',
    hide: false,
    isMandatory: false,
    filter: ColumnFilterType.NUMBER,
    filterId: 'pld_f',
    dbFilter: true,
    filterParams: {
      filterOptions: ['greaterThanOrEqual', 'lessThanOrEqual', 'inRange', 'notBlank'],
      inRangeInclusive: true,
      defaultOption: 'inRange',
      maxNumConditions: 1,
      //allow only number and colon,
      //this pattern doesn't validate target string but only input chars one by one so we can't add something like: \d{2}:[0-50-9]{2}:[0-50-9]{2}
      allowedCharPattern: '\\d:',
      buttons: ['reset'],
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return Util.formatMillisecondDuration(params.value);
    }
  },
  {
    field: 'loadDetails',
    headerName: 'Page Load Details',
    hide: true,
    cellRenderer: LongDataColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        text: params.data?.loadDetails || '',
        type: 'json'
      };
    },
    flex: 1,
    autoHeight: true,
    filter: false,
  },
  {
    field: 'additionalActivityDuration',
    headerName: 'Additional Activity Duration',
    hide: true,
    isMandatory: false,
    filter: ColumnFilterType.NUMBER,
    filterId: 'aad_f',
    dbFilter: true,
    filterParams: {
      filterOptions: ['greaterThanOrEqual', 'lessThanOrEqual', 'inRange', 'notBlank'],
      inRangeInclusive: true,
      defaultOption: 'inRange',
      maxNumConditions: 1,
      //allow only number and colon,
      //this pattern doesn't validate target string but only input chars one by one so we can't add something like: \d{2}:[0-50-9]{2}:[0-50-9]{2}
      allowedCharPattern: '\\d:',
      buttons: ['reset'],
    },
    useValueFormatterForExport: false,
    valueFormatter: (params) => {
      return params.value ? Util.formatMillisecondDuration(params.value) : '';
    }
  },
  {
    field: 'activityBreakdownDisplay',
    headerName: 'Activity Breakdown',
    hide: true,
    flex: 1,
    minWidth: 250,
    autoHeight: true,
    cellRenderer: (params: any) => {
      return params.value ? params.value : '';
    },
    filter: false,
  }
];
